import { DateTime, Interval } from "luxon";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { z } from "zod/v3";
import { PlainMessage, Timestamp } from "@bufbuild/protobuf";
import { KapiInstanceMetadata as ProtoKapiInstanceMetadata } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";

export interface KapiInstanceMetadata {
  instanceName: string;
  location: string;
  createdAt: DateTime;
  scenarioStart: DateTime;
  scenarioEnd: DateTime;
  scenarioInterval: Interval;
}

export const kapiInstanceMetadataSchema = createSchema<
  KapiInstanceMetadata,
  PlainMessage<ProtoKapiInstanceMetadata>
>({
  instanceName: z
    .string()
    .min(1, { message: "KapiInstanceMetadata instanceName should not be empty" }),
  location: z.string().min(1, { message: "KapiInstanceMetadata location should not be empty" }),
  createdAt: z
    .instanceof(Timestamp, { message: "KapiInstanceMetadata created at should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate())),
  scenarioStart: z
    .instanceof(Timestamp, { message: "KapiInstanceMetadata scenario start should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate())),
  scenarioEnd: z
    .instanceof(Timestamp, { message: "KapiInstanceMetadata scenario end should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate())),
}).transform((instance) => ({
  ...instance,
  scenarioInterval: Interval.fromDateTimes(instance.scenarioStart, instance.scenarioEnd),
})) satisfies ZodOutputFor<KapiInstanceMetadata>;
